import { Component } from '@angular/core';
import { CARD_ADMIN } from 'src/app/Interfaces/Admin/Administrator_General.inferface';

@Component({
    selector: 'app-menu-recyclebin-fin',
    templateUrl: './menu-recyclebin-fin.component.html',
    styleUrls: ['./menu-recyclebin-fin.component.scss', '../../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class MenuRecyclebinFINComponent {

  constructor() { }

  //+================== VARIABLES FOR CARDS RECYCLE BIN ==================+\\<i class="fa-regular fa-file-lines"></i>
  public AllRecycleBin: CARD_ADMIN[] = [
    {
      Title: 'Papelera de procesos y directorios',
      Description: 'Puede acceder a la papelera de directorios y proceso de la librería de processes.',
      ButtonText: 'Ver papelera',
      RouteLink: '/Dashboard/FIN/RecycleBin_OFMFIN',
      Icon: 'fa-regular fa-file-lines',
      IconButton: 'fa-solid fa-trash-can'
    },
    {
      Title: 'Papelera de anexos',
      Description: 'Puede acceder a la papelera anexos de la librería de processes.',
      ButtonText: 'Ver papelera anexos',
      RouteLink: '/Dashboard/FIN/RecycleBinAnneFIN',
      Icon: 'fa-regular fa-paste',
      IconButton: 'fa-solid fa-trash-can'
    },
  ]


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

}
